export default "/images/vendor/flag-icon-css/flags/4x3/gb-eng.svg?ee3571430d489c32deaca52df1c49f09";